// api/teachers.js
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';

export async function fetchTeachers(filters = {}) {
  let q = collection(db, 'teachers');

  if (filters.subject || filters.city) {
    const conditions = [];
    if (filters.subject) {
      conditions.push(where('subject', '==', filters.subject));
    }
    if (filters.city) {
      conditions.push(where('city', '==', filters.city));
    }

    q = query(collection(db, 'teachers'), ...conditions);
  }

  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
}
